module.exports = __webpack_public_path__ + "img/sld_abt_disable.2f33aa67.svg";